import styled from 'styled-components'

export const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;

  @media (min-width: 576px) {
    justify-content: flex-start;
  }
`
